import lodash from 'lodash/throttle';

export module MouseStalkerModule {
  export class Service {
    private visible: boolean = false;
    private stalkerElement: HTMLElement | null;
    private stalkerElements: NodeListOf<HTMLElement>;

    constructor() {
      // ストーカーエレメントを取得
      this.stalkerElement = document.querySelector('.StyledMouseStalker.move');

      // js--mouseStalkerクラスを持つエレメントを取得
      this.stalkerElements = document.querySelectorAll('.js--mouseStalker');

      // イベントを設定
      this.initStalkerEvents();
      this.setMouseMoveEvent();

      // 他の初期化処理があればここに
    }

    private initStalkerEvents() {
      this.stalkerElements.forEach(element => {
        element.addEventListener('mouseenter', () => {
          this.setVisible(true);
        });

        element.addEventListener('mouseleave', () => {
          this.setVisible(false);
        });
      });
    }

    private setMouseMoveEvent() {
      const handleMouseMove = (e: MouseEvent) => {
        if (!this.stalkerElement) return;
        this.stalkerElement.style.left = `${e.clientX}px`;
        this.stalkerElement.style.top = `${e.clientY}px`;
      };
      const handleMouseMoveLodash = lodash(handleMouseMove, 100);
      document.addEventListener('mousemove', handleMouseMoveLodash);
    }

    public setVisible(value: boolean) {
      this.visible = value;
      if (!this.stalkerElement) return;

      // visibleがtrueの場合、ストーカーエレメントにvisibleクラスを追加
      // falseの場合は削除
      if (this.visible) {
        this.stalkerElement.classList.add('visible');
      } else {
        this.stalkerElement.classList.remove('visible');
      }
    }
  }
}
